var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';

import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../../I18N";
import { EmbededButton } from "../EmbededButton";


const GroupHeader = () => /*#__PURE__*/_jsx(Translate, { className: "sr-only" }, void 0, "Empty");

const GroupCell = ({ row }) => {
  const canExpand = row.originalSubRows;
  const expanded = row.getIsExpanded();

  return canExpand ? /*#__PURE__*/
  _jsx(EmbededButton, {
    icon: expanded ? /*#__PURE__*/_jsx(ChevronUpIcon, {}) : /*#__PURE__*/_jsx(ChevronDownIcon, {}),
    onClick: () => row.toggleExpanded(),
    color: "indigo",
    className: `${expanded ? 'bg-indigo-300' : 'bg-indigo-100'} rounded-md border-none drop-shadow-none` }, void 0, /*#__PURE__*/

  _jsx(Translate, { className: `${expanded ? 'text-indigo-800' : 'text-indigo-700'}` }, void 0, "Group"), /*#__PURE__*/
  _jsx(Translate, { className: "sr-only" }, void 0, "Open group")
  ) :
  null;
};

export { GroupCell, GroupHeader };